import { useState } from 'react';
import { motion } from 'framer-motion';
import CustomButton from '../../components/CustomButton'; // Importamos el botón
import { url } from 'inspector';
import imaGato from '../../assets/portadas/gato.png';
import ima2 from '../../assets/portadas/mini1.png';
import ima3 from '../../assets/portadas/mini2.png';
import { PingPongGame } from '../../components/games/pingpong';
import { TicTacToe } from '../../components/games/ticTacToe';

const images = [
  imaGato, // Imagen 1
  ima2, // Imagen 2
  ima3, // Imagen 3
  'https://via.placeholder.com/150/FFFF00/0000FF', // Imagen 4
];

const juegos = [
  <TicTacToe />,
  <PingPongGame />,
];

function ExpandingGrid() {
  const [expandedIndex, setExpandedIndex] = useState<number | null>(null);

  const handleExpand = (index: number) => {
    setExpandedIndex(index);
  };

  const handleReset = () => {
    setExpandedIndex(null);
  };

  // Componente personalizado que se renderiza al expandir
  const ExpandedComponent = ({ index }: { index: number }) => {
    return (
      // <div style={{ textAlign: 'center' }}>
      //   <h2>Componente {index + 1}</h2>
      //   <img src={images[index]} alt={`Imagen ${index + 1}`} style={{ width: '200px' }} />
      //   <p>Descripción de la imagen {index + 1}</p>
      //   {/* Aquí renderizamos el botón al hacer clic */}
      //   <CustomButton onClick={() => alert(`Botón en Componente ${index + 1} clicado!`)} />
      // </div>
      juegos.map((juego, index) => (
        juego
      ))
    );
  };

  return (
    <div style={{ width: '400px', height: '400px', position: 'relative' }}>
      {expandedIndex === null ? (
        <motion.div
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gridTemplateRows: '1fr 1fr',
            gap: '10px',
            width: '100%',
            height: '100%',
          }}
        >
          {images.map((image, index) => (
            <motion.div
              key={index}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#f0f0f0',
                border: '1px solid black',
                cursor: 'pointer',
                backgroundImage: image,
                backgroundSize: 'cover',
              }}
              whileHover={{ scale: 1.05 }}
              onClick={() => handleExpand(index)}
            >
              {/* Aquí no renderizamos nada más que el cuadrito con la imagen */}
              {<img src={image} /*style={{ width: '200px', height: '193px' }}*/></img>}
            </motion.div>
          ))}
        </motion.div>
      ) : (
        <motion.div
          style={{
            width: '100%',
            height: '100%',
            backgroundColor: '#f0f0f0',
            border: '1px solid black',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
            padding: '20px',
          }}
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
        >
          {/* Renderizamos el componente expandido */}
          {/* <ExpandedComponent index={expandedIndex} /> */}
          {juegos[expandedIndex]}

          <button
            onClick={handleReset}
            style={{
              position: 'absolute',
              top: '10px',
              right: '10px',
              padding: '5px 10px',
              fontSize: '14px',
              cursor: 'pointer',
            }}
          >
            Reset
          </button>
        </motion.div>
      )}
    </div>
  );
}

export default ExpandingGrid;